package io.horion.cv.components.forms

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.varabyte.kobweb.compose.foundation.layout.Column
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import io.horion.cv.viewModel.CvViewModel
import io.horion.cv.api.datasource.cv.Certificate
import io.horion.cv.components.cards.GenericFormCard
import io.horion.cv.components.cards.SummaryData
import io.horion.cv.components.widgets.AddButton
import io.horion.cv.di.koinGet
import io.horion.cv.models.CertificatState
import org.jetbrains.compose.web.css.px

@Composable
fun CertificatAccordionContent(
    onComplete: (String) -> Unit,
    onAddCertificatAndClose: (String) -> Unit,
) {
    val cvViewModel = koinGet<CvViewModel>()
    val certsFromVM = cvViewModel.cvUiState.data.certificates

    LaunchedEffect(Unit) {
        if (certsFromVM.isEmpty()) {
            cvViewModel.updateCertificate(0, Certificate("", "", ""))
            cvViewModel.editingCertificatId = "certificat-0"
        }
    }

    Column(
        modifier = Modifier.fillMaxWidth(),
        verticalArrangement = Arrangement.spacedBy(30.px),
    ) {
        certsFromVM.forEachIndexed { index, cert ->
            val tempId = "certificat-$index"

            val state = remember(cert) {
                val dateParts = cert.date.split("-")
                CertificatState(
                    id = tempId,
                    certificat = cert.name,
                    mois = dateParts.getOrNull(0) ?: "",
                    annee = dateParts.getOrNull(1) ?: "",
                    isOngoing = cert.date == "En cours",
                    description = cert.description
                )
            }

            GenericFormCard(
                item = state,
                isEditing = cvViewModel.editingCertificatId == tempId,
                onEdit = { cvViewModel.editingCertificatId = tempId },
                onDelete = {
                    cvViewModel.deleteCertificate(index)
                    if (cvViewModel.cvUiState.data.certificates.isEmpty()) {
                        cvViewModel.updateCertificate(0, Certificate("", "", ""))
                        cvViewModel.editingCertificatId = "certificat-0"
                    } else {
                        cvViewModel.editingCertificatId = null
                    }
                },
                onComplete = { cvViewModel.editingCertificatId = null },
                getSummary = { c ->
                    if (c.certificat.isNotBlank()) {
                        val periode = if (c.isOngoing) "En cours" else "${c.mois} ${c.annee}".trim()
                        SummaryData(title = c.certificat, subtitle = periode)
                    } else null
                },
                getDefaultText = { "[Certificat]" },
                formContent = { s, onDel, onComp ->
                    CertificatForm(
                        index = index,
                        state = s,
                        cvViewModel = cvViewModel,
                        onDelete = onDel,
                        onComplete = onComp

                    )
                }
            )
        }

        AddButton(
            text = "Ajouter un certificat",
            onClick = {
                val nextIndex = certsFromVM.size
                cvViewModel.updateCertificate(nextIndex, Certificate("", "", ""))
                cvViewModel.editingCertificatId = "certificat-$nextIndex"
            }
        )
    }
}